module.exports = __webpack_public_path__ + "static/media/inclusion-banner.30fb0c3d.png";